import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import CatalogueFieldList from '../../forms/components/CatalogueFieldList';
import { datasetStepName } from '../../state/state';
import DatasetWizardContentContainer from '../../components/DatasetWizardContentContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../templates/hooks/fetch';

const DatasetCatalogueSection = ({
  category,
  code,
  readErrors,
  section,
  title,
}) => {
  const intl = useIntl();
  const {
    activeStepIndex,
    readStatus,
    saveErrors,
    sectionsWithFields,
    templateCode,
    templateReadStatus,
  } = Selectors.useDatasetCatalogueSection({ category, code });
  Fetch.useFetchCatalogueTemplateForDataset({
    category, code: templateCode, datasetCode: code, templateReadStatus, intl,
  }, readStatus);
  const errors = datasetStepName(activeStepIndex) === sectionsWithFields[sectionsWithFields.length - 1]
    ? saveErrors : [];

  return (
    <DatasetWizardContentContainer
      category={category}
      className="aridhia-dataset-catalogue-section"
      code={code}
      loading={templateReadStatus === states.PENDING}
      readErrors={readErrors}
      saveErrors={errors}
      title={title}
    >
      <CatalogueFieldList code={code} category={category} section={section} />
    </DatasetWizardContentContainer>
  );
};

export default DatasetCatalogueSection;
